import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import Loader from "../Loader";

export default lazyPage(
    "src/front/components/ComposerCard/ComposerCard.tsx",
    () => import("./ComposerCard"),
    <Loader margin="auto" />,
);
